import { useState } from "react";
import { Mic } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PronunciationPractice } from "@/components/PronunciationPractice";

export const MicButton = ({ text, romaji, lang, testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        data-testid={testId}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className="h-8 w-8 rounded-full bg-[hsl(var(--secondary-light))] text-[hsl(var(--secondary-dark))] grid place-items-center hover:scale-105 active:scale-95 transition-transform shrink-0"
        aria-label="Practise saying this"
      >
        <Mic size={15} />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="pronunciation-dialog" className="sm:max-w-md rounded-3xl">
          <DialogTitle className="font-display text-xl font-extrabold text-slate-900">Say it aloud</DialogTitle>
          <DialogDescription className="text-slate-600 -mt-2">Listen first, then record yourself. AI scores your pronunciation.</DialogDescription>
          {open && <PronunciationPractice text={text} romaji={romaji} lang={lang} testPrefix="dialog-pron" />}
        </DialogContent>
      </Dialog>
    </>
  );
};
